import api from "@/api/axios";
import { ElMessage } from 'element-plus'

const auth = {
  namespaced: true,
  
  state: {
    verificationStatus: {
      lastSentTime: null,
      phone: null
    }
  },

  mutations: {
    SET_VERIFICATION_STATUS(state, { phone, time }) {
      state.verificationStatus = {
        lastSentTime: time,
        phone
      }
    },
    
    SET_ERROR(state, error) {
      if (error) {
        ElMessage({
          message: error,
          type: 'error',
          duration: 2000
        })
      }
    }
  },

  actions: {
    /**
     * 发送验证码
     */
    async sendVerificationCode({ commit }, phone) {
      try {
        const response = await api.post('/users/send_phone_code', {
          user_phone: phone,
        })
        
        if (response.data.status === 200) {
          commit('SET_VERIFICATION_STATUS', {
            phone,
            time: new Date().getTime()
          })
          ElMessage.success('验证码发送成功')
          return response.data.data
        } else {
          commit('SET_ERROR', response.data.msg || '发送验证码失败')
          throw new Error(response.data.msg || '发送验证码失败')
        }
      } catch (error) {
        commit('SET_ERROR', error.message || '网络错误，请稍后重试')
        throw error
      }
    },

    /**
     * 手机号注册
     */
    async registerByPhone({ commit }, data) {
      try {
        const response = await api.post('/users/phone-register', {
          phone: data.phone,
          code: data.code,
          password: data.password
        })
        
        if (response.data.status === 200) {
          ElMessage.success('注册成功')
          return response.data.data
        } else {
          commit('SET_ERROR', response.data.msg || '注册失败')
          throw new Error(response.data.msg || '注册失败')
        }
      } catch (error) {
        commit('SET_ERROR', error.message || '网络错误，请稍后重试')
        throw error
      }
    },

    async sendResetEmail({ commit }, { email }) {
      try {
        const response = await api.post('/users/send-email-code', { 
          user_email: email 
        })
        
        if (response.data.status === 200) {
          ElMessage.success('重置邮件发送成功')
          return response.data.data
        } else {
          commit('SET_ERROR', response.data.msg || '发送失败')
          throw new Error(response.data.msg || '发送失败')
        }
      } catch (error) {
        commit('SET_ERROR', error.message || '网络错误，请稍后重试')
        throw error
      }
    },

    async verifyPhoneCode({ commit }, { phone, code }) {
      try {
        const response = await api.post('/api/auth/verify-phone-code', {
          phone,
          code
        });
        
        if (response.data.valid) {
          return true;
        } else {
          commit('SET_ERROR', '验证码错误或已过期')
          throw new Error('验证码错误或已过期');
        }
      } catch (error) {
        if (error.response) {
          const message = error.response.data.message || '验证码验证失败';
          commit('SET_ERROR', error.message || '验证码验证失败')
          throw new Error(message);
        }
        throw error;
      }
    }
  },

  getters: {
    canSendCode: (state) => (phone) => {
      if (!state.verificationStatus.lastSentTime) return true
      if (state.verificationStatus.phone !== phone) return true
      
      const now = new Date().getTime()
      const diff = now - state.verificationStatus.lastSentTime
      return diff >= 60000 // 60秒后可以重新发送
    }
  }
}

export default auth